// Equinoxes and solstices via Jean Meeus' polynomial approximation
// (Astronomical Algorithms, 2nd ed., ch. 27). Accurate to ~1 minute for
// years 1000-3000. Returns the date in Paris local time (close enough to
// UT+1/+2 — the seasons fall on the same calendar day except for edge cases
// rarely visible to the calendar grid).

type SeasonKey = 'PRINTEMPS' | 'ETE' | 'AUTOMNE' | 'HIVER';

interface Coeffs {
  a: number; b: number; c: number; d: number; e: number;
}

const TABLE: Record<SeasonKey, Coeffs> = {
  // March equinox
  PRINTEMPS: { a: 2451623.80984, b: 365242.37404, c: 0.05169, d: -0.00411, e: -0.00057 },
  // June solstice
  ETE:       { a: 2451716.56767, b: 365241.62603, c: 0.00325, d:  0.00888, e: -0.00030 },
  // September equinox
  AUTOMNE:   { a: 2451810.21715, b: 365242.01767, c: -0.11575, d: 0.00337, e:  0.00078 },
  // December solstice
  HIVER:     { a: 2451900.05952, b: 365242.74049, c: -0.06223, d: -0.00823, e: 0.00032 },
};

function julianDay(year: number, key: SeasonKey): number {
  const Y = (year - 2000) / 1000;
  const { a, b, c, d, e } = TABLE[key];
  return a + b * Y + c * Y * Y + d * Y * Y * Y + e * Y * Y * Y * Y;
}

function jdToDate(jd: number): Date {
  // Convert Julian Day to JS Date (UTC), then move to local TZ.
  const ms = (jd - 2440587.5) * 86400000;
  return new Date(ms);
}

export function seasonDate(year: number, key: SeasonKey): Date {
  return jdToDate(julianDay(year, key));
}

export function allSeasons(year: number): Array<{ key: SeasonKey; date: Date }> {
  return (Object.keys(TABLE) as SeasonKey[]).map((key) => ({ key, date: seasonDate(year, key) }));
}
